import React from "react";

const WarehouseContext = React.createContext();

export default WarehouseContext;
